import { render, staticRenderFns } from "./dragVerify.vue?vue&type=template&id=04bf95fc&scoped=true"
import script from "./dragVerify.vue?vue&type=script&lang=js"
export * from "./dragVerify.vue?vue&type=script&lang=js"
import style0 from "./dragVerify.vue?vue&type=style&index=0&id=04bf95fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04bf95fc",
  null
  
)

export default component.exports